import { forwardRef } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const ArrowDown02Linear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
});
